<template>
  <div class="container">
    <div class="title">{{ $t('recharge').Depositcoins }}</div>
    <div class="info">
      <div class="left">
        <!-- 选择币种 -->
        <div class="tit">{{ $t('recharge').Rechargecurrency }}</div>
        <PopoverSelect :items="currencyArr" :onSelect="onSelectCurrency">
          <template #reference>
            <div class="selInfo">
              <div class="left">
                <img class="img" :src="require(`@/assets/img/${currency}.png`)" />
                <div class="name">
                  <div class="t1">{{ currency }}</div>
                  <div class="t2">{{ $t('recharge').RechargecurrencyTips }}</div>
                </div>
              </div>
              <van-icon name="play" size="13" class="ric" color="var(--text_color)" />
            </div>
          </template>
        </PopoverSelect>
        <!-- 选择网络 -->
        <div class="tit">{{ $t('recharge').network }}</div>
        <PopoverSelect :items="networkArr" :onSelect="onSelectNetwork">
          <template #reference>
            <div class="networkInfo">{{ network }}
              <span> <van-icon name="play" size="13" class="ric" color="var(--text_color)" /></span>
            </div>
          </template>
        </PopoverSelect>
        <!-- 二维码地址 -->
        <div class="addressInfo" v-if="Address">
          <qrcode-vue :value="Address" :size="130" level="H" class="qrcode"></qrcode-vue>
          <div class="tit">{{ $t('recharge').Depositaddress }}</div>
          <div class="address">
            <span>{{ Address }}</span>
            <svg-icon class-name="svgs" icon-class="copy" @click="onCopy(Address)" />
          </div>
        </div>
        <!-- 充值到账 -->
        <div class="tit">{{ $t('recharge').Rechargetoaccount }}</div>
        <PopoverSelect :items="assetTypeArr" :onSelect="onSelectAssetType">
          <template #reference>
            <div class="accountInfo">{{ assetType == 3 ? $t('asset').Spotaccount : $t('asset').Walletaccount }}
              <span> <van-icon name="play" size="13" class="ric" color="var(--text_color)" /></span>
            </div>
          </template>
        </PopoverSelect>
      </div>
      <div class="right">
        <!-- 充币数量 -->
        <div class="tit">{{ $t('recharge').Rechargequantity }}</div>
        <div class="numInfo">
          <van-field v-model="Amount" type="number" :placeholder="$t('recharge').amountMsg">
            <template #right-icon>
              <span style="color: var(--ntext_color)">{{ currency }}</span>
            </template>
          </van-field>
          <div class="selNum">
            <div class="item" v-for="(item, index) in numArr" :key="`num${index}`" @click="onSelectNum(item, index)"
              :class="selNumIndex == index ? 'active' : ''">{{ item }}</div>
          </div>
        </div>
        <!-- 转账凭证 -->
        <div class="tit">{{ $t('recharge').Paymentvoucher }}</div>
        <div class="unImg">
          <van-uploader :after-read="justAfterRead">
            <img v-if="Voucher" :src="baseUrl + Voucher" width="250" />
            <svg-icon v-else class-name="svgs" icon-class="up" />
          </van-uploader>
        </div>
        <div class="lables">{{ $t('recharge').Youneedtorecharge }}<span>{{ Amount }} {{ currency }}</span>
        </div>
        <!-- 按钮 -->
        <van-button block :loading="btnloading" @click="handleSub">{{ $t('recharge').Rechargenow }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
import QrcodeVue from 'qrcode.vue'
import PopoverSelect from '@/components/popoverSelect.vue'
import { EventBus } from '@/utils/event-bus'

export default {
  components: {
    QrcodeVue,
    PopoverSelect
  },
  data() {
    return {
      btnloading: false,
      baseUrl: window.baseURL,
      addressList: [],
      currency: 'USDT',
      currencyArr: [],
      network: '',
      networkArr: [],
      allnetworkArr: [],
      currencyNetwork: [],
      assetType: 4,
      numArr: [200, 500, 1000, 2000, 10000],
      selNumIndex: 0,
      Voucher: '',
      Address: '',
      Amount: '',
    }
  },
  computed: {
    assetTypeArr() {
      return [
        { text: this.$t('asset').Walletaccount, val: 4 },
        { text: this.$t('asset').Spotaccount, val: 3 },
      ]
    },
  },
  async mounted() {
    EventBus.$on('btnloading', () => {
      this.btnloading = false
    })
    window.scrollTo(0, 0);
    this.Amount = this.numArr[0]
    this.getWalletAddressList()
  },
  methods: {
    //系统钱包地址
    async getWalletAddressList() {
      const res = await systemApi.getWalletAddressList()
      this.addressList = res.walletAddress
      this.currencyArr = Array.from(new Map(this.addressList.map(item => [item.currency, { text: item.currency, val: item.currency }])).values());
      this.currency = this.currencyArr[0].val
      this.OnNetwork()
    },
    //网络赋值
    OnNetwork() {
      this.networkArr = Array.from(new Map(this.addressList.filter(item => item.currency === this.currency).map(item => [item.network, { text: item.network, val: item.network }])).values())
      this.network = this.networkArr[0].val
      this.onChangeAll()
    },
    //选择币种
    async onSelectCurrency(action) {
      this.currency = action.text
      this.OnNetwork()
    },
    //选择网络
    async onSelectNetwork(val) {
      this.network = val.text
      this.onChangeAll()
    },
    //选择资产账户
    async onSelectAssetType(action) {
      this.assetType = action.val
    },
    //选择数量
    onSelectNum(val, index) {
      this.Amount = val
      this.selNumIndex = index
    },
    //选择变动地址图片
    onChangeAll() {
      this.Address = ''
      var info = this.addressList.filter(item => item.currency == this.currency && item.network == this.network);
      if (info.length > 0) this.Address = info[0].address
      else this.$toast(this.$t('recharge').notsupportedAddress)
    },
    // 凭证
    async justAfterRead(file) {
      const formdata = new FormData()
      formdata.append('file', file.file)
      var res = await systemApi.UploadFile(formdata)
      this.Voucher = res.fileName
    },
    //复制方法
    onCopy(text) {
      return new Promise((resolve) => {
        if (navigator.clipboard?.writeText) {
          this.$toast(this.$t('public').copySuccess)
          return resolve(navigator.clipboard.writeText(text))
        }
        const textarea = document.createElement('textarea')
        document.body.appendChild(textarea)
        textarea.style.position = 'absolute'
        textarea.style.clip = 'rect(0 0 0 0)'
        textarea.value = text
        textarea.select()
        document.execCommand('copy', true)
        textarea.remove()
        this.$toast(this.$t('public').copySuccess)
        return resolve(true)
      })
    },
    // 提交
    async handleSub() {
      if (!this.Address) {
        this.$toast(this.$t('recharge').notsupportedAddress)
        return false
      }
      if (!this.assetType) {
        this.$toast(this.$t('recharge').selectaccount)
        return false
      }
      if (!this.Amount) {
        this.$toast({ message: this.$t('recharge').amountMsg })
        return false
      }
      if (!this.Voucher) {
        this.$toast({ message: this.$t('recharge').VoucherMsg })
        return false
      }
      const form = {
        amount: this.Amount,
        assetType: this.assetType,
        currency: this.currency,
        network: this.network,
        address: this.Address,
        voucher: this.Voucher,
      }
      this.btnloading = true
      await userApi.rechargeCurrency(form)
      this.btnloading = false
      this.$toast({ message: this.$t('recharge').subMsg })
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .title {
    font-size: 36px;
    font-weight: bold;
    color: var(--text_color);
    margin: 0 auto;
    max-width: 1280px;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--info_color);
    margin-bottom: 30px;
  }

  .info {
    margin: 0 auto;
    max-width: 1280px;
    display: flex;
    justify-content: space-between;

    .left {
      width: 50%;
      margin-right: 50px;
    }

    .right {
      width: 50%;
    }

    .tit {
      margin-top: 10px;
      font-size: 13px;
      color: var(--text_color);
    }

    .ric {
      transform: rotate(90deg);
    }

    .selInfo {
      margin: 10px 0 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      padding: 15px;

      &:hover {
        border: 1px solid var(--text_color);
      }

      .left {
        display: flex;
        align-items: center;

        .img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
        }

        .name {
          margin-left: 10px;

          .t1 {
            font-size: 16px;
            font-weight: bold;
            color: var(--text_color);
          }

          .t2 {
            margin-top: 10px;
            font-size: 13px;
            color: var(--ntext_color);
          }
        }

      }
    }

    .networkInfo {
      margin: 10px 0 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      padding: 15px;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);

      &:hover {
        border: 1px solid var(--text_color);
      }
    }

    .addressInfo {
      margin-bottom: 20px;

      .qrcode {
        margin: 20px auto;
        width: 150px;
        height: 150px;
        border: 1px solid var(--info_color);
        border-radius: 10px;
        padding: 10px;
      }

      .address {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;

        span {
          width: 88%;
          margin-right: 20px;
          overflow-wrap: break-word;
          font-size: 15px;
          font-weight: bold;
          color: var(--text_color);
        }

        .svgs {
          width: 15px;
          height: 15px;
          color: var(--text_color);
        }
      }
    }

    .accountInfo {
      margin: 10px 0 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      padding: 15px;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);
      &:hover {
        border: 1px solid var(--text_color);
      }
    }

    .numInfo {
      margin: 10px 0 20px 0;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      padding: 10px;

      .selNum {
        margin-top: 10px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .item {
          width: 30%;
          text-align: center;
          padding: 10px 0;
          font-size: 13px;
          color: var(--text_color);
          background: var(--info_color);
          margin: 5px;
          border-radius: 10px;
        }

        .active {
          border: 1px solid #FF9B37;
        }
      }
    }

    .unImg {
      margin-top: 10px;
      text-align: center;
      border: 1px solid var(--info_color);
      border-radius: 10px;
      padding: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 150px;

      .svgs {
        width: 50px;
        height: 50px;
        color: var(--text_color);
      }

    }

    .lables {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
      color: var(--ntext_color);

      span {
        color: var(--text_color);
        font-weight: bold;
      }

    }

    .van-button {
      margin: 10px 0 30px 0;
      background: var(--text_color);
      height: 50px;
      border-radius: 25px;
      border: 0;
      font-size: 16px;
      color: var(--background_color);

      &:hover {
        opacity: 0.8;
      }
    }
  }
}

.itemss {
  padding: 15px;
  font-size: 14px;
  color: var(--text_color);

  &:hover {
    opacity: 0.7;
  }

  &:active {
    background: var(--background_color);
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

.van-cell {
  background: var(--background_color);
  border-bottom: 1px solid var(--info_color);
  height: 50px;
  padding: 10px;
  font-size: 20px;
  font-weight: bold;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__right-icon {
  margin: -10px 8px;
  padding: 0px;
  line-height: normal;
  font-size: 15px;
}
</style>
